import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient singleton da aplicação.
 *
 * Extraído de `main.tsx` para ser importável também fora da árvore React
 * (ex.: `setup-api-client.ts`, handlers de auth) — necessário para limpar o
 * cache do React Query nas transições de IDENTIDADE.
 *
 * Por que existe `resetSessionCache()`: o app é uma SPA, então logout→login
 * NÃO recarrega a página e este singleton (com todo o server-state cacheado)
 * sobrevive à troca de usuário. Como as query keys são por-usuário implícito
 * (ex.: `['agent-dashboard','state']`, sem userId), o novo usuário receberia
 * dados cacheados do anterior até a query expirar. Limpar o cache em toda
 * transição de identidade (login / logout / 401) garante slate limpo —
 * é o que o F5 fazia "por acidente" ao recriar o singleton.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 min — alinha com cache Redis do Engine
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Limpa TODO o server-state cacheado. Chamar em qualquer transição de
 * identidade (login, logout, sessão expirada) — o cache inteiro pertence ao
 * dono anterior. Mais robusto que invalidar por-chave (que exigiria enumerar
 * todas as keys do app).
 */
export function resetSessionCache(): void {
  queryClient.clear();
}
